import moment = require("moment");
import { utilities } from "uicomponents";
import { ViewModel } from "./binder/uiPatterns/mvvm/viewmodel";
declare var persianDate:(any)=>void;

export class Converters{
    notConverter(t){
        return !t;
    }

    b64ToSrcConverter(t){
        return `data:image/png;base64,${t}`;
    }
    b64ToSrcConverterReverse(t){
        if(t && utilities.isString(t) && t.indexOf(',')>-1)
            return t.split(',')[1];
        return null;
    }

    rgbaToArgbString(v){
        let a = ("0"+((v & 0xFF000000) >>> 24).toString(16)).slice(-2);
        let r = ("0"+((v & 0x00FF0000) >>> 16).toString(16)).slice(-2);
        let g = ("0"+((v & 0x0000FF00) >>> 8).toString(16)).slice(-2);
        let b = ("0"+((v & 0x000000FF) >>> 0).toString(16)).slice(-2);
        let result = `#${r}${g}${b}${a}`;
        return result;
    }

    localDateConverter(d:moment.Moment):string{
        if(d==null) return '';
        if(d instanceof String || typeof d=='string') d=moment(d);
        d = d.clone().local();
        let date = new persianDate(d.toDate());

        let result = date.format(`YYYY/MM/DD HH:mm:ss`)
        
        return result;
    }
    DatePartLocalDateConverter(d:moment.Moment):string{
        if(d==null) return '';
        if(d instanceof String || typeof d=='string') d=moment(d);
        d = d.clone().local();
        let date = new persianDate(d.toDate());

        let result = date.format(`YYYY/MM/DD`)
        
        return result;
    }
    TimePartLocalDateConverter(d:moment.Moment):string{
        if(d==null) return '';
        if(d instanceof String || typeof d=='string') d=moment(d);
        d = d.clone().local();
        let result = d.format(`HH:mm:ss`)
        
        return result;
    }
    NumberWithCommas(x) {
        return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    RemoveCommas(x:string){
        return x?.replace(/\,/g,"");
    }
}
